import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { RegisterNewUser, RegisterNewEditor } from '../../actions/user.js';
import TopNav from '../includes/TopNav';
import RegisterForm from './registerform2';
class Register extends Component{
  constructor(props) {
    super(props);
  }
  submit = (values) => {
    this.props.dispatch(RegisterNewEditor(values, this.props.Paper));
    this.props.history.push('/');
  }
  render() {
      return (
        <div>
         <TopNav />
          <section className="thankyou">
            <div>
              <div className="banner-row">
                Register Today!
                <div className="small-banner">Become an Editor.</div>
              </div>
              <div className="thanks-form-container">
                  <div className="thanks-form-lead">Create an account</div>
                  <RegisterForm onSubmit={this.submit} />
                  <Link to="/login">Already a member? Log in here!</Link>
              </div>
            </div>
          </section>
       </div>
    )
  }
}

export default connect(
  ({Paper, Modals, User})=>({Paper, Modals, User})
)(Register);

// <input type="text" placeholder="email" value={this.props.User.email || null} /><br/>
// <input type="text" placeholder="name" /><span>optional</span><br/>
// <input type="text" placeholder="number" /><span>optional</span><br/>
// <button className="button">Register</button><br/><br/>



// WEBPACK FOOTER //
// ./src/components/User/Register.js